import { Switch, Route } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { PracticesCqsProvider } from "../contexts/practices-cqs-context";
import { PracticesLoansProvider } from "../contexts/practices-loans-context";
import { UserProvider } from "../contexts/user-context";
import { ServiceProvider } from "../contexts/service-context";
import UserInfoPage from "../components/users/user-info/user-info";
import { UserFeeProvider } from "../contexts/user-fee-context";

const MeContent = ({ match }) => {
  const { user: cognitoUser } = useAuthenticator();

  const role =
    cognitoUser?.signInUserSession?.accessToken?.payload?.[
      "cognito:groups"
    ]?.[0] ?? "CLIENTE";

  const isAdmin = role === "ADMIN";

  return (
    <div className="users-page">
      <Switch>
        <Route
          exact
          path={match.path}
          render={(routeProps) => (
            <UserInfoPage
              {...routeProps}
              fallbackUserId={cognitoUser.username}
              isAdmin={isAdmin}
            />
          )}
        />
      </Switch>
    </div>
  );
};

const Me = ({ match }) => {
  return (
    <UserProvider>
      <ServiceProvider>
        <PracticesCqsProvider>
          <PracticesLoansProvider>
            <UserFeeProvider>
              <MeContent match={match} />
            </UserFeeProvider>
          </PracticesLoansProvider>
        </PracticesCqsProvider>
      </ServiceProvider>
    </UserProvider>
  );
};

export default Me;
